<template lang="pug">
div.labelAnuncios(v-if="resolvedBanners.length && $root.podeAcessarPerfil(['administrador'])", :class="{ 'labelAnuncios--card': variant === 'card' }")
  //- Variante CARD (usada na Home)
  template(v-if="variant === 'card'")
    div.announce-card(v-for="banner in resolvedBanners", :key="banner.id", :style="cardStyle(banner)")
      div.announce-card__icon(:style="{ background: bannerColor(banner) }")
        v-icon(color="white", size="22") {{ banner.icon }}
      div.announce-card__title(:style="`color: ${bannerColor(banner)}`") {{ banner.title }}
      div.announce-card__msg {{ banner.message }}
      div.announce-card__actions
        v-btn.announce-card__btn(depressed, :color="bannerColor(banner)", dark, @click="handleCta(banner)") {{ banner.cta.label }}
        a.announce-card__dismiss(v-if="banner.dismissible", @click="dismiss(banner)") Agora não
  //- Variante INLINE (padrão — demais telas)
  template(v-else)
    div(v-for="banner in resolvedBanners", :key="banner.id")
      v-card(flat, :style="bannerStyle(banner)")
        v-card-text.pa-2
          v-layout(row, align-center, wrap)
            v-icon.mr-2(:color="bannerColor(banner)", size="18") {{ banner.icon }}
            span.body-1.font-weight-bold(:style="`color: ${bannerColor(banner)}`") {{ banner.title }}
            span.body-2.ml-2.grey--text.text--darken-1 — {{ banner.message }}
            v-spacer
            v-btn(flat, small, :color="bannerColor(banner)", @click="handleCta(banner)").pa-0.ma-0.ml-2
              | {{ banner.cta.label }}
            v-btn(flat, small, v-if="banner.dismissible", @click="dismiss(banner)", color="grey").pa-0.ma-0.ml-2
              | Agora não
</template>

<script>
import { TIPO_CANCELAMENTO_TESTE } from '@/util/estabelecimentoBloqueio'

const COLORS = {
  success: { text: '#1d9a5a', bg: 'rgba(29,154,90,0.08)',  border: '#1d9a5a' },
  info:    { text: '#0060C8', bg: 'rgba(0,96,200,0.06)',   border: '#0060C8' },
  warning: { text: '#CC7A00', bg: 'rgba(255,149,0,0.08)',  border: '#FF9500' },
  danger:  { text: '#C62828', bg: 'rgba(229,57,53,0.08)',  border: '#E53935' },
}

const vendasBaixas = (ctx) =>
  ctx.qtdSemanaPassada >= 3 && ctx.qtdHoje < ctx.qtdSemanaPassada * 0.6

const ANNOUNCEMENT_REGISTRY = [
  {
    id: 'baixa_nunca_usou_cupom',
    priority: 1,
    dismissible: true,
    dismissTtlDays: 1,
    icon: 'trending_down',
    type: 'warning',
    title: 'Vendas abaixo do esperado hoje',
    message: 'Você teve menos pedidos que na semana passada. Ative um cupom para atrair mais clientes agora.',
    cta: { label: 'Criar cupom agora', route: 'cupomDesconto' },
    condition: (vm, ctx) =>
      vendasBaixas(ctx) && ctx.usadosAlgumaDia === 0 && ctx.ativos.length === 0
  },
  {
    id: 'baixa_ja_usou_cupom',
    priority: 2,
    dismissible: true,
    dismissTtlDays: 1,
    icon: 'trending_down',
    type: 'warning',
    title: 'Movimento mais fraco hoje',
    message: 'Você teve menos pedidos que na semana passada. Que tal ativar um cupom para impulsionar as vendas?',
    cta: { label: 'Ver cupons', route: 'cupomDesconto' },
    condition: (vm, ctx) =>
      vendasBaixas(ctx) && ctx.usadosAlgumaDia > 0
  },
  {
    id: 'cupons_expirados_sem_ativo',
    priority: 3,
    dismissible: true,
    dismissTtlDays: 3,
    icon: 'event_busy',
    type: 'warning',
    title: 'Seus cupons expiraram',
    message: 'Você não tem cupons ativos no momento. Crie um novo para manter a vantagem competitiva.',
    cta: { label: 'Criar novo cupom', route: 'cupomDesconto' },
    condition: (vm, ctx) =>
      ctx.cupons.length > 0 && ctx.ativos.length === 0
  },
  {
    id: 'nunca_criou_cupom',
    priority: 4,
    dismissible: true,
    dismissTtlDays: null,
    icon: 'local_offer',
    type: 'success',
    title: 'Crie seu primeiro cupom',
    message: 'Cupons aumentam pedidos em até 30%. Leva menos de 2 minutos para criar.',
    cta: { label: 'Criar meu primeiro cupom', route: 'cupomDesconto' },
    condition: (vm, ctx) => ctx.cupons.length === 0
  },
  {
    id: 'criou_nunca_usado',
    priority: 5,
    dismissible: true,
    dismissTtlDays: 3,
    icon: 'visibility_off',
    type: 'info',
    title: 'Seu cupom ainda não foi usado',
    message: 'Divulgue seu cupom nas redes sociais ou ative como destaque para aumentar a visibilidade.',
    cta: { label: 'Ver meus cupons', route: 'cupomDesconto' },
    condition: (vm, ctx) =>
      ctx.ativos.length > 0 && ctx.usadosAlgumaDia === 0
  },
  {
    id: 'fds_sem_cupom',
    priority: 6,
    dismissible: true,
    dismissTtlDays: 1,
    icon: 'weekend',
    type: 'info',
    title: 'Final de semana chegando!',
    message: 'Pedidos aumentam no final de semana. Crie um cupom especial para aproveitar o movimento.',
    cta: { label: 'Criar cupom especial', route: 'cupomDesconto' },
    condition: (vm, ctx) => {
      const dia = vm.$dayjs().day() // 5=sexta, 6=sábado
      return (dia === 5 || dia === 6) && ctx.ativos.length === 0
    }
  },
  {
    id: 'pico_sem_cupom',
    priority: 7,
    dismissible: true,
    dismissTtlDays: 1,
    icon: 'schedule',
    type: 'info',
    title: 'Horário de maior movimento!',
    message: 'Das 17h às 21h os pedidos aumentam. Um cupom ativo agora pode destacar sua loja da concorrência.',
    cta: { label: 'Criar cupom', route: 'cupomDesconto' },
    condition: (vm, ctx) => {
      const hora = vm.$dayjs().hour()
      return hora >= 17 && hora <= 20 && ctx.ativos.length === 0
    }
  },
  {
    id: 'sem_cupom_primeiro_pedido',
    priority: 8,
    dismissible: true,
    dismissTtlDays: 7,
    icon: 'person_add',
    type: 'info',
    title: 'Atraia clientes novos',
    message: 'Você não tem cupom de primeiro pedido. Um incentivo inicial converte visitantes em clientes.',
    cta: { label: 'Criar cupom de 1º pedido', route: 'cupomDesconto' },
    condition: (vm, ctx) =>
      ctx.ativos.length > 0 &&
      !ctx.ativos.some(c => c.primeiro_pedido_estabelecimento == 1)
  },
  {
    id: 'sem_cupom_entrega_gratis',
    priority: 9,
    dismissible: true,
    dismissTtlDays: 7,
    icon: 'local_shipping',
    type: 'info',
    title: 'Ofereça entrega grátis',
    message: 'Cupons de entrega grátis aumentam a conversão em até 25%. Você ainda não tem um.',
    cta: { label: 'Criar cupom de entrega grátis', route: 'cupomDesconto' },
    condition: (vm, ctx) =>
      ctx.ativos.length > 0 &&
      !ctx.ativos.some(c => c.entrega_gratis)
  }
]

export default {
  props: {
    estabelecimentoId: { type: Number, required: true },
    variant: { type: String, default: 'inline' }
  },
  data () {
    return {
      resolvedBanners: [],
      loading: false
    }
  },
  mounted () {
    this.evaluateAll()
  },
  watch: {
    estabelecimentoId (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.resolvedBanners = []
        this.evaluateAll()
      }
    }
  },
  methods: {
    async evaluateAll () {
      if (!this.estabelecimentoId) return
      const suspensa = this.$root.estabelecimentoSelecionado?.status_delivery == 4
      if (suspensa) {
        this.resolvedBanners = []
        return
      }
      this.loading = true

      let cupons = [], pedidosHoje = [], pedidosAnterior = [], pedidos28d = []
      try {
        const hoje = this.$dayjs()
        const semanaPassada = hoje.subtract(7, 'day')
        const fmt = d => d.format('YYYY-MM-DD HH:mm:ss')
        const [rc, rh, ra, r28] = await Promise.all([
          this.$axios.get('/cupom-desconto', {
            params: { estabelecimento_id: this.estabelecimentoId }
          }),
          this.$axios.get('/pedido', {
            params: {
              estabelecimento_id: this.estabelecimentoId,
              data_inicio: fmt(hoje.startOf('day')),
              data_fim: fmt(hoje.endOf('day')),
              statusList: '1,2',
              orderDesc: 'data'
            }
          }),
          this.$axios.get('/pedido', {
            params: {
              estabelecimento_id: this.estabelecimentoId,
              data_inicio: fmt(semanaPassada.startOf('day')),
              data_fim: fmt(semanaPassada.endOf('day')),
              statusList: '1,2',
              orderDesc: 'data'
            }
          }),
          this.$axios.get('/pedido', {
            params: {
              estabelecimento_id: this.estabelecimentoId,
              data_inicio: fmt(hoje.subtract(28, 'day').startOf('day')),
              data_fim: fmt(hoje.subtract(1, 'day').endOf('day')),
              statusList: '1,2,3',
              orderDesc: 'data'
            }
          })
        ])
        cupons = rc.data || []
        pedidosHoje = rh.data || []
        pedidosAnterior = ra.data || []
        pedidos28d = r28.data || []
      } catch (e) { /* prefetch falhou — nenhum banner, pedidos seguem normais */ }

      const hoje = this.$dayjs()
      const ativos = cupons.filter(o =>
        o.ativo === 1 && (!o.data_fim || !this.$dayjs(o.data_fim).isBefore(hoje, 'day'))
      )

      const pedidos28dValidos = pedidos28d.filter(
        o => Number(o.tipo_cancelamento) !== TIPO_CANCELAMENTO_TESTE
      )
      const totalPedidos28d = pedidos28dValidos.length
      const cancelados28d = pedidos28dValidos.filter(o => o.status === 3)
      const taxaCancelamento28d = totalPedidos28d > 0
        ? (cancelados28d.length / totalPedidos28d) * 100
        : 0
      const bloqueadoCancelamento = totalPedidos28d > 0 && (
        (totalPedidos28d > 10 && taxaCancelamento28d > 50) ||
        (totalPedidos28d <= 10 && taxaCancelamento28d > 75)
      )

      const ctx = {
        cupons,
        ativos,
        usadosAlgumaDia: cupons.reduce((sum, c) => sum + (c.utilizados || 0), 0),
        qtdHoje: pedidosHoje.length,
        qtdSemanaPassada: pedidosAnterior.length,
        bloqueadoCancelamento,
      }

      if (bloqueadoCancelamento) {
        this.resolvedBanners = []
        this.loading = false
        return
      }

      const sorted = [...ANNOUNCEMENT_REGISTRY].sort((a, b) => a.priority - b.priority)
      const results = []
      for (const def of sorted) {
        if (this.isDismissed(def)) continue
        try {
          if (def.condition(this, ctx)) results.push(def)
        } catch (e) { /* silently skip */ }
      }
      this.resolvedBanners = results.slice(0, 1)
      if (this.resolvedBanners.length) {
        this.$firebase.logEvent('banner_shown', {
          banner_type: this.resolvedBanners[0].id,
          establishment_id: this.estabelecimentoId,
        })
      }
      this.loading = false
    },
    isDismissed (banner) {
      const val = localStorage.getItem(`bigou_banner_${banner.id}_${this.estabelecimentoId}`)
      if (!val) return false
      if (!banner.dismissTtlDays) return true
      return this.$dayjs().diff(this.$dayjs(val), 'day') < banner.dismissTtlDays
    },
    dismiss (banner) {
      this.$firebase.logEvent('banner_dismissed', {
        banner_type: banner.id,
        establishment_id: this.estabelecimentoId,
      })
      localStorage.setItem(
        `bigou_banner_${banner.id}_${this.estabelecimentoId}`,
        this.$dayjs().toISOString()
      )
      this.resolvedBanners = this.resolvedBanners.filter(b => b.id !== banner.id)
    },
    handleCta (banner) {
      this.$firebase.logEvent('banner_cta_clicked', {
        banner_type: banner.id,
        establishment_id: this.estabelecimentoId,
        destination_route: banner.cta.route || 'custom_action',
      })
      if (banner.cta.action) return banner.cta.action(this)
      if (banner.cta.route) this.$router.push({ name: banner.cta.route })
    },
    bannerColor (banner) {
      return (COLORS[banner.type] || COLORS.info).text
    },
    bannerStyle (banner) {
      const c = COLORS[banner.type] || COLORS.info
      return `background: ${c.bg}; border-left: 3px solid ${c.border};`
    },
    cardStyle (banner) {
      const c = COLORS[banner.type] || COLORS.info
      return `background: ${c.bg}; border: 1px solid ${c.border}26;`
    }
  }
}
</script>

<style lang="scss" scoped>
.labelAnuncios {
  height: auto;

  &--card {
    height: 100%;
    display: flex;
  }
}

// ===== Variante CARD =====
.announce-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 22px;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  font-family: 'Poppins', 'Roboto', sans-serif;
}

.announce-card__icon {
  width: 46px;
  height: 46px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  flex-shrink: 0;
}

.announce-card__title {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 8px;
}

.announce-card__msg {
  font-size: 13px;
  color: #5b6472;
  line-height: 1.6;
  flex: 1 1 auto;
}

.announce-card__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.announce-card__btn {
  flex: 1 1 auto;
  min-width: 150px;
  margin: 0 !important;
  height: 42px !important;
  border-radius: 11px !important;
  font-weight: 700;
  font-size: 13.5px;
  text-transform: none;
  letter-spacing: 0;
  font-family: 'Poppins', 'Roboto', sans-serif;
  box-shadow: none !important;
}

.announce-card__dismiss {
  padding: 0 12px;
  font-size: 12.5px;
  font-weight: 600;
  color: #9aa1ab;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s;

  &:hover {
    color: #6b7280;
    text-decoration: underline;
  }
}
</style>
